/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHoursSummaryForEmployee} from '../api'

 export const useQueryGetHoursSummaryForEmployee = createReactQueryHook('getHoursSummaryForEmployee', getHoursSummaryForEmployee)
